import { type TimeWindowsPayload, type TimeWindowsResponse, timeWindowsResponseSchema } from '@repo/types/time-windows';
import { fetcher } from '@repo/utils';

import { type ServicesBasePath } from './services.utils';

export const getTimeWindows = async (
    servicesBasePath: ServicesBasePath,
    payload: TimeWindowsPayload
): Promise<TimeWindowsResponse> => {
    const url = `${servicesBasePath}/time-windows`;
    const response = await fetcher(url, {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            'Content-Type': 'application/json',
        },
    });
    const data = await response.json();
    return timeWindowsResponseSchema.parse(data);
};
